import { defineComponent } from "vue";
import StatsNumerical from "./StatsNumerical.vue";
import { liveStore } from "@live/store/LiveStore";
import LoadingIndicator from "@common/vue/LoadingIndicator.vue";
import StdBarChart from "@live/vue/chart/bar/StdBarChart.vue";
import { maxTwoDecimalDigit } from "@common/utils/Number";
import StdDoughnutChart from "@live/vue/chart/doughnut/StdDoughnutChart.vue";
import StdLineChart from "@live/vue/chart/line/StdLineChart.vue";
import { StatsApi } from "@live/api/stats/StatsApi";
import { unixToHourMinuteZulu } from "@common/utils/Time";
import { metrePerSecondToKnot } from "@common/utils/UnitConverter";
export default defineComponent({
    components: {
        StatsNumerical,
        LoadingIndicator,
        StdBarChart,
        StdDoughnutChart,
        StdLineChart
    },
    data: function () {
        return {
            isLoading: true,
            violation1: {
                average: 0,
                median: 0,
                deviation: 0
            },
            violation2: {
                average: 0,
                median: 0,
                deviation: 0
            },
            violation3: {
                average: 0,
                median: 0,
                deviation: 0
            },
            violationTotal: {
                average: 0,
                median: 0,
                deviation: 0
            },
            flightTime: {
                average: 0,
                median: 0,
                deviation: 0
            },
            landings: {
                average: 0,
                median: 0,
                deviation: 0
            },
            experience: {
                average: 0,
                median: 0,
                deviation: 0
            },
            atcOps: {
                average: 0,
                median: 0,
                deviation: 0
            },
            topDepartures: {
                labels: [""],
                values: [0]
            },
            topArrivals: {
                labels: [""],
                values: [0]
            },
            topAircraftType: {
                labels: [""],
                values: [0]
            },
            serverLoad: {
                labels: [""],
                values: [0]
            },
            topBusiests: {
                labels: [""],
                values: [0]
            },
            topAircraft: {
                labels: [""],
                values: [0]
            },
            topXP: {
                labels: [""],
                values: [0]
            },
            gradeDistribution: {
                labels: [""],
                values: [0]
            },
            topFlightTimes: {
                labels: [""],
                values: [0]
            },
            topAtcOps: {
                labels: [""],
                values: [0]
            },
            topLandings: {
                labels: [""],
                values: [0]
            },
            topSpeeds: {
                labels: [""],
                values: [0]
            },
        };
    },
    mounted: async function () {
        const getTime = () => Math.floor(new Date().getTime());
        const server = liveStore.getters.getCurrentServerSimple;
        if (server == null) {
            return;
        }
        const t0 = getTime();
        const minDelay = 1000;
        const stats = await StatsApi.getServerStats(server.id, this.$store.getters.getJwtToken);
        const set = () => {
            const setStatsNumerical = (field, stats) => {
                field.average = maxTwoDecimalDigit(stats.average);
                field.median = maxTwoDecimalDigit(stats.median);
                field.deviation = maxTwoDecimalDigit(stats.stdDeviation);
            };
            const setStatsChart = (field, labels, values) => {
                field.labels = labels;
                field.values = values;
            };
            setStatsNumerical(this.violation1, stats.violation1);
            setStatsNumerical(this.violation2, stats.violation2);
            setStatsNumerical(this.violation3, stats.violation3);
            setStatsNumerical(this.violationTotal, stats.violationTotal);
            {
                const flightTime = Object.assign({}, stats.flightTime);
                flightTime.average /= 3600;
                flightTime.median /= 3600;
                flightTime.stdDeviation /= 3600;
                setStatsNumerical(this.flightTime, flightTime);
            }
            setStatsNumerical(this.landings, stats.landings);
            setStatsNumerical(this.experience, stats.xp);
            setStatsNumerical(this.atcOps, stats.atcOperations);
            setStatsChart(this.topDepartures, stats.topDepartureAirports.map((value) => value.first), stats.topDepartureAirports.map((value) => value.second));
            setStatsChart(this.topArrivals, stats.topArrivalAirports.map((value) => value.first), stats.topArrivalAirports.map((value) => value.second));
            setStatsChart(this.serverLoad, stats.pilotCountsRecent.map((value) => unixToHourMinuteZulu(value.first)), stats.pilotCountsRecent.map((value) => value.second));
            setStatsChart(this.topAircraftType, stats.topAircraftTypes.map((value) => value.first), stats.topAircraftTypes.map((value) => value.second));
            setStatsChart(this.topBusiests, stats.topBusiestAirports.map((value) => value.first), stats.topBusiestAirports.map((value) => value.second));
            setStatsChart(this.topAircraft, stats.topAircraftLiveries.map((value) => value.first), stats.topAircraftLiveries.map((value) => value.second));
            setStatsChart(this.topXP, stats.topXps.map((value) => value.first), stats.topXps.map((value) => value.second));
            setStatsChart(this.gradeDistribution, stats.gradesDistribution.map((value) => `${value.first}`), stats.gradesDistribution.map((value) => value.second));
            setStatsChart(this.topFlightTimes, stats.topFlightTimes.map((value) => value.first), stats.topFlightTimes.map((value) => value.second / 3600));
            setStatsChart(this.topAtcOps, stats.topAtcOperations.map((value) => value.first), stats.topAtcOperations.map((value) => value.second));
            setStatsChart(this.topLandings, stats.topLandings.map((value) => value.first), stats.topLandings.map((value) => value.second));
            setStatsChart(this.topSpeeds, stats.topSpeeds.map((value) => value.first), stats.topSpeeds.map((value) => metrePerSecondToKnot(value.second)));
            this.isLoading = false;
        };
        const deltaT = getTime() - t0;
        if (deltaT > minDelay) {
            set();
        }
        else {
            setTimeout(set, minDelay - deltaT);
        }
    }
});
